type OrderStore = {id: string; platform: string; active?: boolean};

// Retired Amazon stores remain available for viewing order history.
export function customerOrderSelectableStores<T extends OrderStore>(stores: T[]): T[] {
  return stores.filter(store => store.active !== false || store.platform === 'amazon');
}

export function customerOrderSyncTargetStores<T extends OrderStore>(stores: T[], storeId: string): T[] {
  return stores.filter(store =>
    store.active !== false && store.platform !== 'amazon' && (storeId === 'all' || store.id === storeId)
  );
}
